export const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "1rem",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
  };
  export const thStyle = {
    backgroundColor: "#F4F4F4",
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "left",
    fontWeight: "bold",
  };
  export const tdStyle = {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "left",
  };
  export const rowHoverStyle = {
    transition: "background 0.2s ease",
  };